import { render, staticRenderFns } from "./BbppCommercialDowngradeBM.vue?vue&type=template&id=41e35c42"
import script from "./BbppCommercialDowngradeBM.vue?vue&type=script&lang=js"
export * from "./BbppCommercialDowngradeBM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports